module.exports = __webpack_public_path__ + "img/CM-SS-CA-Chevy-Lifestyle.39c0f2a6.jpg";